import React, { useState, useEffect, useContext,useRef } from "react";
import { Navigate } from 'react-router-dom';
import "./style.css";
import ImageUpload from "../../../components/ImageUpload";
import BoardPost from "../BoardPost";
import { AuthContext } from "../../../context/AuthContext";

/** 게시판 리스트 */
function BoardList() {
  const [posts, setPosts] = useState([]); // 게시글 목록을 저장할 상태
  const [isFormOpen, setIsFormOpen] = useState(false); // 폼의 토글 상태
  const { isLoggedIn, user } = useContext(AuthContext);
  const handlePostSuccess = () => {
    getBoardData(user.id); // 게시글 목록 갱신
  };

  // 게시글 데이터 가져오기
  const getBoardData = async (userId) => {
    // 여기에 비동기 통신 로직 구현
    try {
      const response = await fetch(`api/board?userId=${userId}`, {
        headers: {
          Accept: "application / json",
        },
        method: "GET",
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      setPosts(data); // 서버에서 받은 데이터로 상태를 업데이트합니다.
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (isLoggedIn && user) {
      getBoardData(user.id); // 여기에서 사용자 아이디를 전달합니다.
    }
  }, [isLoggedIn]); // user를 의존성 배열에 추가합니다.
 // 로그인 상태 변경시에만 실행

  // 로그인 상태가 아니면 로그인 페이지로 리다이렉트
  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }

  //리스트의 결과를 result에 저장
  const result = posts.map((data) => (
    <BoardPost
      key={data.ID}
      id={data.node_id}
      title={data.title}
      content={data.content}
      user_name={data.user_name}
      file={data.file_name}
    />
  ));

  return (
    <div className="board-list">
      <div className="boardListHeader">
        <h2>게시글 목록</h2>
        <button className="postingBtn" onClick={() => setIsFormOpen(true)}>
          글쓰기
        </button>
      </div>
      {isFormOpen && (
        <PostForm
          refresh={handlePostSuccess}
          closeForm={() => setIsFormOpen(false)}
        />
      )}
      {result.length > 0 ? result : <p>게시글이 없습니다.</p>}
    </div>
  );
}


/**글쓰기 */
function PostForm({ refresh, closeForm }) {
  //포스팅 저장 후 페이지를 리렌더링하기 위해 getBoardData를 가져옴
  const [postUserName, setPostUserName] = useState("");
  const [postTitle, setPostTitle] = useState("");
  const [postContent, setPostContent] = useState("");
  const [postFile, setPostFile] = useState(null); // 파일 상태
  const { user } = useContext(AuthContext); // 로그인된 사용자 정보 가져오기

  useEffect(() => {
    if (user && user.name) {
      setPostUserName(user.id); // 로그인된 사용자의 이름으로 설정
    }
  }, [user]);


  /** file 타입 저장 */
  const handleFileChange = (event) => {
    setPostFile(event.target.files); // 첫 번째 선택된 파일을 저장
  };

  /**저장하기 */
  const myFormData = useRef();
  const handleSubmit = () => {
    if (postTitle.trim() && postContent.trim() && postFile) {
      const formData = new FormData(myFormData.current);
      formData.append("name", postUserName);
      formData.append("title", postTitle);
      formData.append("content", postContent);
      formData.append("files", postFile);

      fetch("/api/postings", {
        method: "POST",
        body: formData, // JSON이 아닌 FormData 사용
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          alert("게시글이 성공적으로 작성되었습니다!");
          refresh(); // 게시글 리렌더링

          // 입력 필드를 초기화합니다.
          setPostTitle("");
          setPostContent("");
          setPostFile(null); // 파일 입력 필드를 초기화합니다.
        })
        .catch((error) => {
          console.error("Error creating post:", error);
        });
    } else {
      alert("Title, content, and file are required!");
    }
  };

  return (
    <div className="postFormBox">
      <h2>글쓰기</h2>
      <form ref={myFormData}>
      <div className="post-form">
        <input
          className="userNameInput"
          defaultValue={postUserName}
          onChange={(e) => setPostUserName(e.target.value)}
          readOnly 
          placeholder="작성자"
        />

        <input
          className="postTitleInput"
          value={postTitle}
          onChange={(e) => setPostTitle(e.target.value)}
          placeholder="제목"
        />
        <textarea
          className="postContentInput"
          value={postContent}
          onChange={(e) => setPostContent(e.target.value)}
          placeholder="내용"
        />
        <input
          name="Myfiles"
          type="file"
          className="fileInput"
          onChange={handleFileChange}
          placeholder="파일"
          multiple
        />
        <div className="button-container">
          <button type="button" className="formSubmitBtn" onClick={handleSubmit}>
            저장
          </button>
          <button
            typq="button"
            className="closeBtn"
            onClick={() => closeForm(false)}
          >
            취소
          </button>
        </div>
        {/* <ImageUpload /> */}
      </div>
      </form>
    </div>
  );
}

export { BoardList, PostForm };
